import { AuthService as authService } from '../../common/auth.service';

class LoginDialogController implements angular.IOnInit {
  public username: string;
  public password: string;

  public isLoading: boolean;
  public reLogin: boolean = false;

  /** @ngInject */
  constructor(private authService: authService, private $mdDialog: angular.material.IDialogService) { }

  $onInit(): void {
    this.isLoading = false;
  }

  login = () => {
    this.reLogin = true;
    if (this.username != undefined) {
      this.isLoading = true;
      this.username = this.username.toLowerCase();
      this.authService.login(this.username, this.password, true)
        .then(
          (response) => this.$mdDialog.hide(true),
          (errResp) => this.$mdDialog.hide(false)
        ).finally(() => this.isLoading = false);
    } else {
      this.isLoading = false;
    }
    this.reLogin = false;
  }
}

export const loginDialog: angular.IComponentOptions = {
  template: require('./login.dialog.html'),
  controller: LoginDialogController
}



// WEBPACK FOOTER //
// ./src/app/login/login-dialog/login-dialog.ts